module.exports = {"TXTWCL_Promotion_History":{"id":"TXTWCL_Promotion_History","defaultMessage":"Historie akcí"}}